import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCard = ({ icon, label, value, trend, trendValue, color }) => {
  return (
    <div className="p-4 rounded-lg border border-[var(--color-border)] bg-[var(--color-card)]">
      <div className="flex items-start justify-between mb-3">
        <div
          className="p-2 rounded-lg"
          style={{ backgroundColor: `${color}15` }}
        >
          <Icon name={icon} size={20} color={color} />
        </div>
        {trend && (
          <div
            className={`flex items-center gap-1 text-xs font-medium ${
              trend === 'up' ? 'text-[var(--color-success)]' : 'text-[var(--color-error)]'
            }`}
          >
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={12} />
            <span>{trendValue}</span>
          </div>
        )}
      </div>
      <div className="text-2xl font-bold text-[var(--color-foreground)] mb-1">
        {value}
      </div>
      <div className="text-sm text-[var(--color-muted-foreground)]">
        {label}
      </div>
    </div>
  );
};

export default QuickStatsCard;